<svg
  [attr.height]="size"
  [attr.width]="size"
>
  <circle
    class="progress"
    fill="transparent"
    [attr.stroke-width]="strokeWidth"
    [attr.stroke-dasharray]="strokeDasharray"
    [attr.stroke-dashoffset]="offset"
    [attr.r]="radius"
    [attr.cx]="halfsize"
    [attr.cy]="halfsize"
  />
  <circle
    class="background"
    fill="transparent"
    [attr.stroke-width]="strokeWidth"
    [attr.r]="radius"
    [attr.cx]="halfsize"
    [attr.cy]="halfsize"
  />
</svg>
